import { hideTutorial } from "..";
import { triggerDrawControl } from "../..";

let tutorial_closeButton = <HTMLButtonElement>document.querySelector('.tutorial_closeButton');

export function initTutorial() {

    tutorial_closeButton.addEventListener("touchend", () => {
        triggerDrawControl('resume');
    });

}